import { alpha } from '@mui/material';

export default theme => ({
  container: {
    width: '100%',
    paddingLeft: theme.spacing(4)
  },
  row: {
    whiteSpace: 'nowrap',
    width: '100%'
  },
  value: {
    color: alpha(theme.palette.secondary.main, 0.54),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: theme.spacing(0.5),
    maxWidth: 470
  }
});
